export const CATALOGO_ACTIVIDADES_ECONOMICAS_STP = [
  { id: '55', value: 'ADMINISTRACIÓN DE INMUEBLES' },
  { id: '70', value: 'ADMINISTRADORAS DE TARJETA DE CRÉDITO' },
  { id: '67', value: 'AGENCIA ADUANAL' },
  { id: '57', value: 'CASA DE CAMBIO' },
  { id: '54', value: 'CASAS DE BOLSA NACIONALES' },
  { id: '66', value: 'CENTROS CAMBIARIOS' },
  { id: '56', value: 'COMPAÑÍAS DE SEGUROS NACIONALES' },
  { id: '59', value: 'COMPRAVENTA DE ARTÍCULOS DE PLATA' },
  { id: '63', value: 'COMPRAVENTA DE AUTOMÓVILES Y CAMIONES NUEVOS' },
  { id: '64', value: 'COMPRAVENTA DE CASAS Y OTROS INMUEBLES' },
  { id: '49', value: 'COMPRAVENTA DE GAS PARA USO DOMESTICO O COMERCIAL' },
  { id: '60', value: 'COMPRAVENTA DE OTRAS JOYAS' },
  { id: '61', value: 'COMPRAVENTA DE RELOJES' },
  { id: '58', value: 'CONSTRUCCIÓN DE INMUEBLES' },
  { id: '50', value: 'CONTRATACIÓN DE OBRAS COMPLETAS DE CONSTRUCCIÓN (CASAS, DEPARTAMENTOS, INMUEBLES, PAVIMENTACIÓN, NO RESIDENCIALES, VÍAS DE COMUNICACIÓN)' },
  { id: '72', value: 'EMPRESAS TRANSPORTADORAS DE VALORES' },
  { id: '45', value: 'ESTABLECIMIENTOS PRIVADOS DE INSTRUCCIÓN, EDUCACIÓN, CULTURA E INVESTIGACIÓN' },
  { id: '69', value: 'FACTORING' },
  { id: '30', value: 'FINTECH - CROWDFOUNDING' },
  { id: '32', value: 'FINTECH - MONEDAS VIRTUALES' },
  { id: '31', value: 'FINTECH - WALLET' },
  { id: '37', value: 'INSTITUCIONES FINANCIERAS DEL EXTRANJERO' },
  { id: '73', value: 'JUEGOS DE FERIA Y APUESTAS' },
  { id: '34', value: 'MANUFACTURA' },
  { id: '68', value: 'MONTEPIO O CASAS DE EMPEÑO' },
  { id: '71', value: 'NOTARIAS PUBLICAS' },
  { id: '33', value: 'SERVICIOS - OUTSOURCING' },
  { id: '28', value: 'SERVICIOS - PASARELA DE PAGOS' },
  { id: '29', value: 'SERVICIOS - TURÍSTICOS' },
  { id: '43', value: 'SERVICIOS DE AGENCIAS DE COLOCACIÓN Y SELECCIÓN DE PERSONAL' },
  { id: '42', value: 'SERVICIOS DE ANÁLISIS DE SISTEMAS Y PROCESAMIENTO ELECTRÓNICO DE DATOS' },
  { id: '62', value: 'SERVICIOS DE BLINDAJE' },
  { id: '41', value: 'SERVICIOS DE BUFETES JURÍDICOS' },
  { id: '53', value: 'SERVICIOS DE ENSEÑANZA COMERCIAL Y DE IDIOMA' },
  { id: '51', value: 'SERVICIOS DE ENSEÑANZA PRE PRIMARIA Y PRIMARIA' },
  { id: '52', value: 'SERVICIOS DE ENSEÑANZA SECUNDARIA' },
  { id: '38', value: 'SERVICIOS DE INSTITUCIONES DE CRÉDITO, ORGANIZACIONES AUXILIARES E INSTITUCIONES DE SEGUROS Y FIANZAS' },
  { id: '44', value: 'SERVICIOS MEDICO GENERAL Y ESPECIALIZADO EN CONSULTORIOS' },
  { id: '40', value: 'SERVICIOS PROFESIONALES Y TÉCNICOS' },
  { id: '39', value: 'SERVICIOS RELACIONADOS CON INMUEBLES' },
  { id: '47', value: 'SOCIEDADES DE AHORRO Y CRÉDITO POPULAR' },
  { id: '48', value: 'SOCIEDADES DE INVERSIÓN' },
  { id: '36', value: 'SOCIEDADES FINANCIERAS DE OBJETO MÚLTIPLE NO REGULADAS' },
  { id: '35', value: 'SOCIEDADES FINANCIERAS DE OBJETO MÚLTIPLE REGULADAS' },
  { id: '65', value: 'TARJETA DE CRÉDITO' },
  { id: '74', value: 'TRANSMISORES DE DINERO O DISPERSORES' },
  { id: '0', value: 'Otro' }
];

export const MX_SECTORS = [
  'Otro no incluido en la lista anterior',
  'Agricultura; plantaciones, otros sectores rurales',
  'Alimentación; bebidas; tabaco ',
  'Comercio',
  'Construcción',
  'Educación',
  'Fabricación de material de transporte',
  'Función pública',
  'Hotelería, restauración, turismo',
  'Industrias químicas',
  'Ingenieria mecánica y eléctria',
  'Medios de comunicación; cultura; gráficos',
  'Minería (carbón, otra minería)',
  'Petroleo y producción de gas; refinación de petroleo',
  'Producción de metales básicos',
  'Servicios de correos y de telecomunicaciones',
  'Servicios de salud',
  'Servicios financieros; servicios profesionales',
  'Servicios públicos (agua; gas; electricidad)',
  'Silvicultura; madera; celulosa; papel',
  'Textiles; vestido; cuero; calzado',
  'Transporte (inluyendo aviación civil; ferrocarriles; transporte por carretera)',
  'Transporte marítimo; puertos; pesca; transporte interior'
]
